// extracted by mini-css-extract-plugin
export default {"container":"ServerMessagesItem_container__GFFmR","messageContent":"ServerMessagesItem_messageContent__yat6-"};